import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./LocationPage.css";
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import RiyadhShowroomBanner from "../../assets/images/riyadh-showroom.jpg";
import { CalendarClock, MapPin, PhoneCall } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function LocationPage() {
  const { t } = useTranslation();

  return (
    <div className="Page">
      <div className="locationPageBanner text-center">
        <div className="page-banner-content">
          <h3>{t("locationPage.bannerSubtitle")}</h3>
          <h1>{t("locationPage.bannerTitle")}</h1>
        </div>
      </div>

      <Container fluid>
        <div className="section-spacing">
          <p className="brand-section-desc text-center mb-0">
            {t("locationPage.tagline")}
          </p>
        </div>

        <Row>
          <Col md={5}>
            <div className="showroom-pic">
              <img src={RiyadhShowroomBanner} alt={t("locationPage.showroomAlt")} />
            </div>
          </Col>

          <Col md={7}>
            <div className="location-details">
              <h3>{t("locationPage.riyadh.title")}</h3>
            </div>

            <Row>
              <Col md={6}>
                <div className="location-details">
                  <div className="location-data text-center mt-4">
                    <div className="location-icon-holder mb-2">
                      <PhoneCall />
                    </div>

                    <div className="location-subdata">
                      <h5>{t("locationPage.riyadh.contactLabel")}</h5>
                      <a href="tel:8001240664">8001240664</a>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <div className="location-data text-center mt-4">
                  <div className="location-icon-holder mb-2">
                    <MapPin />
                  </div>

                  <div className="location-subdata">
                    <h5>{t("locationPage.riyadh.addressLabel")}</h5>
                    <a
                      href="https://maps.app.goo.gl/nFcCguNArbaEVaST8?g_st=iw"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {t("locationPage.riyadh.addressValue")}
                    </a>
                  </div>
                </div>
              </Col>

              <Col md={12}>
                <div className="location-data text-center mt-4">
                  <div className="location-icon-holder mb-2">
                    <CalendarClock />
                  </div>

                  <div className="location-subdata">
                    <h5>{t("locationPage.riyadh.hoursLabel")}</h5>
                    <p>{t("locationPage.riyadh.days")}</p>
                    <p>{t("locationPage.riyadh.time")}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <div className="location-map">
          <iframe
            title={t("locationPage.mapTitle")}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.864978891304!2d46.798778899999995!3d24.6381961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0729f48095f1%3A0xea5a4a23b7659451!2zTEFOREtJTkcgfCDZhNin2YbYr9mD2YbYrA!5e1!3m2!1sen!2ssa!4v1771249656339!5m2!1sen!2ssa"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Container>

      <div className="section-spacing-top">
        <AftersalesSupportSection />
      </div>
    </div>
  );
}